import React from "react";
import developmentI from '../../images/home/development.png';

function WebsiteDevelopment() {
  return (
    <>

      <Hero />

      <section className="service-content-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={developmentI}
                alt="Website Development"
                className="service-main-image"
              />
            </div>

            <div className="col-lg-6">
              <div className="service-content">

                <h2>Professional Websites For Your Business</h2>

                <p>
                  Your website is often the first interaction customers have
                  with your business. We create professional websites that
                  clearly communicate your brand and services.
                </p>

                <p>
                  We work with WordPress, PHP, .NET, and modern web
                  technologies to build websites that are responsive,
                  maintainable, and business-focused.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Features />
      <CTA />
    </>
  );
}

function Hero() {
  return (
    <section
      className="service-page-hero"
      style={{ backgroundColor: '#002952' }}
    >
      <div className="container">
        <div className="service-hero-content">

          <h1>Website Development</h1>
          <p style={{ color: '#FF7D37' }}>
            Professional websites that help businesses build credibility and
            grow their online presence.
          </p>
        </div>
      </div>
    </section>
  );
}

function Features() {
  return (


    <section className="service-features-section">

      <div className="container">
        <div className="section-heading text-center">

          <h2>Everything Your Website Needs</h2>
        </div>

        <div className="row g-4">
          {[
            ["Business Websites", "Professional websites designed around your brand and business goals."],
            ["WordPress Development", "Flexible WordPress websites that are easy to manage and update."],
            ["PHP & .NET", "Custom websites and solutions using reliable backend technologies."]
          ].map(([title, text]) => (
            <div className="col-lg-4 col-md-6" key={title}>
              <div className="service-feature-card">
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

  );

}

function CTA() {
  return (
    <section className="service-cta-section">
      <div className="container">
        <div className="service-cta-box">
          <div>
            <span>BUILD YOUR ONLINE PRESENCE</span>
            <h2>Need A New Website?</h2>
            <p>Let's create a website that represents your business.</p>
          </div>
          <a href="/contactus" className="service-cta-button">
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}

export default WebsiteDevelopment;